import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ExtractPropTypes } from 'types';
import TeamInfo from '../TeamInfo/TeamInfo.component';

type TeamInfoProps = ExtractPropTypes<typeof TeamInfo>;

type TeamInfoFieldProps = FieldRenderProps<string, HTMLElement> & TeamInfoProps;

const TeamInfoField: React.FC<TeamInfoFieldProps> = (props): JSX.Element => {
  const {
    input: { meta, ...restOfInput },
    ...rest
  } = props;

  return <TeamInfo {...restOfInput} {...rest} />;
};

export default TeamInfoField;
